import styled from 'styled-components';
import { outlineGray } from '../config/colors';

const common = {
  input: `
        padding: 12px 10px;
        box-sizing: border-box;
        border: 1px solid ${outlineGray};
        border-radius: 3px;
        font-size: 0.875rem;
        text-overflow: ellipsis;
    `,
};

export const ScreenWrapper = styled.div`
  display: flex;
  flex: 1;
  position: relative;
  background-image: ${({ background }) => (background ? `url(${background})` : '')};
  background-size: cover;
`;

export const ScrollerWrapper = styled.div`
  display: flex;
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: ${({ background }) => background};
  overflow-x: hidden;
`;

export default common;
